import Api from '@/api/user/api.js'

export default {
    
    /**
     *      Route pour recuperer les utilisateurs  
     */
    users () {
        const promise = Api().get('/allusers')
        return promise.then((response) => response.data)
    }


}